import {useUser} from "../../../util/userContext/UserContext";

type AuthorityNameType = 'orderReadYn' |
    'orderWriteYn' |
    'endReadYn' |
    'endWriteYn' |
    'boardReadYn' |
    'boardWriteYn' |
    'taxReadYn' |
    'taxWriteYn' |
    'shipmentReadYn' |
    'shipmentWriteYn' |
    'accountsReceivableReadYn' |
    'accountsReceivableWriteYn' |
    'productReadYn' |
    'productWriteYn' |
    'inventoryReadYn' |
    'inventoryWriteYn' |
    'inboundReadYn' |
    'inboundWriteYn' |
    'outboundReadYn' |
    'outboundWriteYn' |
    'adjustmentReadYn' |
    'adjustmentWriteYn' |
    'detailsReadYn' |
    'detailsWriteYn' |
    'analysisReadYn' |
    'analysisWriteYn' |
    'clientReadYn' |
    'clientWriteYn' |
    'contactReadYn' |
    'contactWriteYn' |
    'projectReadYn' |
    'projectWriteYn' |
    'tierReadYn' |
    'tierWriteYn' |
    'faqReadYn' |
    'faqWriteYn' |
    'qnaReadYn' |
    'qnaWriteYn' |
    'rmaReadYn' |
    'rmaWriteYn' |
    'accountReadYn' |
    'accountWriteYn' |
    'roleReadYn' |
    'roleWriteYn' |
    'itemReadYn' |
    'itemWriteYn' |
    'salesReadYn' |
    'salesWriteYn' |
    'overseasReadYn' |
    'overseasWriteYn' |
    'barcodeReadYn' |
    'barcodeWriteYn'

interface Props {
    authorityNames: AuthorityNameType[]
    children: React.ReactNode
}

export default function AuthorityChecker({authorityNames, children}: Props) {
    const {user} = useUser()

    if (authorityNames.some((authorityName) => user?.authority[authorityName] === 'Y')) {
        return <>{children}</>
    } else {
        return <></>
    }
}